<template>
  <div v-cloak>
    <div class="flex w-full flex-wrap gap-y-4">
      <div class="flex-grow">
        <vs-input
          :label="$t('ItemCode')"
          v-model="gridSearchData.itemCode"
          @keyup.enter="submitFilter"
          v-trim-space
        />
      </div>
      <div class="flex-grow flex justify-end items-end gap-4">
        <vs-button type="filled" color="#3ec9d6" @click.prevent="resetForm">{{
          $t("ResetFilter")
        }}</vs-button>
        <vs-button type="filled" @click.prevent="submitFilter">{{
          $t("SubmitFilter")
        }}</vs-button>
      </div>
    </div>
    <div class="vx-row pt-4">
      <div class="vx-col w-full mb-base">
        <data-grid
          ref="grid"
          stripe
          :data-source="gridDataSource"
          :search-data="gridSearchData"
          :columns="[
            { title: $t('ItemCode') },
            { title: $t('Price') },
            { title: $t('User') },
            { title: $t('CreateOn') },
          ]"
        >
          <template slot-scope="{ row }">
            <td style="width: 15%">
              {{ row.itemCode }}
            </td>
            <td style="width: 15%">
              {{ row.price.toLocaleString() }}
            </td>
            <td style="width: 20%">
              {{ row.userName }}
            </td>
            <td style="width: 40%">
              {{ row.persianCreateOn.split(" ")[0] }}<br />{{
                row.persianCreateOn.split(" ")[1]
              }}
            </td>
          </template>
        </data-grid>
      </div>
    </div>
  </div>
</template>

<script>
import DataGrid from "@/components/datagrid/DataGrid";
import ProductPopup from "../ProductPopup.vue";
export default {
  name: "saleManagement_Contract_Management_BaseSalePrice",
  components: {
    DataGrid,
    ProductPopup,
  },
  data() {
    var id = this.$route.params.id;
    return {
      gridDataSource: {
        type: "app",
        service: `/Sales/api/BaseSalePriceQuery/${id}/histories-of-base-sale-price`,
      },
      gridSearchData: {},
    };
  },
  mounted() {},
  methods: {
    submitFilter() {
      this.$refs.grid.renderGrid(1, true);
    },
    resetForm() {
      this.gridSearchData = {};
      setTimeout(() => {
        this.$refs.grid.renderGrid(1, true);
      }, 10);
    },
  },
};
</script>

<style scoped></style>
